<script lang="ts">
    import {pipe} from 'core/utils';
    import {encodeUri, loc} from 'shared/utils/pipes';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import type {MoreShowableViewableExemplar} from '../types';
    import type {Document, LabeledIdentified} from 'typings/portaro.be.types';
    import {getDateFormatter} from 'core/svelte-context/context';
    import {createEventDispatcher} from 'svelte';
    import {Kind} from 'shared/constants/portaro.constants';
    import Label from 'shared/components/kp-label/Label.svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let document: Document;
    export let exemplar: MoreShowableViewableExemplar;
    export let property: LabeledIdentified<string>;

    const dispatch = createEventDispatcher<{ 'show-more': void }>();
    const dateFormatter = getDateFormatter();
</script>

<td class="col_{property.id}">
    {#if property.id === 'placement'}
        <KpButton buttonSize="sm" on:click={() => dispatch('show-more')}>
            <UIcon icon={exemplar.showMore ? 'zoom-out' : 'zoom-in'}
                   label={exemplar.showMore ? 'Zavřít umístění' : 'Otevřít umístění'}/>
        </KpButton>
    {:else if property.id === 'fileDirectory' && exemplar.fileDirectory}
        <a href="/media-viewer?rootDirectory={document.directoryId}&back={pipe(window.location.href, encodeUri())}#!?directory={exemplar.fileDirectory.id}">
            {pipe(exemplar.fileDirectory, loc()) ?? ''}
        </a>
    {:else if property.id === 'holder'}
        {#if exemplar.holderDetailShowable && exemplar.holder}
            <Label labeled={exemplar.holder} explicitKind={Kind.KIND_USER}/>
        {/if}
        {#if !exemplar.holderDetailShowable && exemplar.holderShowable && exemplar.holder}
            {pipe(exemplar.holder, loc()) ?? ''}
        {/if}
    {:else if property.id === 'creationDate'}
        {pipe(exemplar.creationDate, dateFormatter('d.M.yyyy'))}
    {:else}
        {pipe(exemplar[property.id], loc()) ?? ''}
    {/if}
</td>